<template>
<div class="sidebar main-sidebar">
	<h1>Explore Special Economic Zones</h1>
	<grid flat class="tabs-caption">
		<grid-item size="1/2">
			<h3 class="pos-left" :class="activeTab == 0 ? 'active' : ''" @click="activeTab = 0">Opportunities</h3>
		</grid-item>
		<grid-item size="1/2">
			<h3 class="pos-right" :class="activeTab == 1 ? 'active' : ''" @click="activeTab = 1">Companies</h3>
		</grid-item>
	</grid>
	<grid flat class="tabs-content" v-if="activeTab == 0">
		<grid-item size="1/1">
			<custom-multiple-select
				label="Search by Sector"
				:itemList="sectors"
				itemValue="id"
				v-model="selectedSectors"
			/>
			<custom-multiple-select
				label="Search by Region"
				:itemList="regions"
				itemValue="id"
				v-model="selectedRegions"
			/>
			<hr>
			<button class="button primary" @click="search()">View on map</button>
		</grid-item>
	</grid>
	<grid class="tabs-content" v-if="activeTab == 1">
		<grid-item size="1/1">
			<custom-multiple-select
				label="Search by Sector"
				:itemList="sectors"
				itemValue="id"
				v-model="selectedSectors"
			/>
			<custom-multiple-select
				label="Search by Region"
				:itemList="regions"
				itemValue="id"
				v-model="selectedRegions"
			/>
			<hr>
			<button class="button primary" @click="search()">View on map</button>
		</grid-item>
	</grid>
</div>
</template>

<script>
import CustomMultipleSelect from '@/components/secondary/CustomMultipleSelect'
import { mapActions, mapState } from 'vuex'

export default {
	components: {
		CustomMultipleSelect
	},
	data: () => ({
		activeTab: 0,
		selectedSectors: [],
		selectedRegions: []
	}),
	computed: {
		...mapState({
			sectors: ({ SectorStore }) => {
				let total = 0
				let items = SectorStore.list.map(item => {
					total += item.count
					item.name = item.name + ' (' + item.count + ')'
					item.disabled = (item.count < 1)
					return item
				})
				items.unshift({
					id: 0,
					name: 'All (' + total + ')',
					disabled: false
				})
				return items
			},
			regions: ({ RegionStore }) => {
				let total = 0
				let items = RegionStore.list.map(item => {
					total += item.count
					item.name = item.name + ' (' + item.count + ')'
					item.disabled = (item.count < 1)
					return item
				})
				items.unshift({
					id: 0,
					name: 'All (' + total + ')',
					disabled: false
				})
				return items
			},
		})
	},
	mounted() {
		this.getSectors()
		this.getRegions()
	},
	methods: {
		...mapActions({
			getSectors: 'SectorStore/getList',
			getRegions: 'RegionStore/getList'
		}),
		search() {
			this.$router.push({
				name: 'opportunity-list',
				query: {
					...this.$route.query,
					sectorId: this.selectedSectors,
					regionId: this.selectedRegions
				}
			})
		}
	}
}
</script>

<style lang="scss">
</style>
